export const BASE_URL = "https://ajantapharma.coact.co.in";
export const API_URL = `${BASE_URL}/apis`;
